import { BaseButton } from '@/shared/components'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
import { ReactElement } from 'react'
import { formatCurrency } from '@/shared/lib'
import { Currencies } from '@/entities/curency'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'

export type InfoBlockModel = { label: string | ReactElement; data: string | ReactElement }[]

type Props = {
  info: InfoBlockModel
  currencyRub?: number
  currencyUsdt?: number
  confirmButton?: boolean
  onConfirm?: () => void
  direction?: 'col' | 'row'
}

export const BaseBanner = ({
  info,
  currencyRub,
  currencyUsdt,
  confirmButton,
  onConfirm,
  direction,
}: Props) => {
  const isMobile = useIsMobile()

  return (
    <>
      {isMobile || direction === 'col' ? (
        <div className="flex flex-col gap-6 bg-light-purple dark:bg-dark-purple px-5 py-6 rounded-2xl">
          {currencyRub && currencyUsdt && (
            <div className="flex justify-between items-center">
              <CopyBlock text={currencyRub?.toFixed(2)} className="font-klein font-medium text-lg">
                {formatCurrency(currencyRub, Currencies.RUB)}
              </CopyBlock>

              <CopyBlock
                text={currencyUsdt?.toFixed(2)}
                className="font-klein font-medium"
                color="secondary"
              >
                {formatCurrency(currencyUsdt, Currencies.USDT)}
              </CopyBlock>
            </div>
          )}

          <div className="flex flex-col gap-[10px]">
            {info.map((el, i) => (
              <div
                key={i}
                className="flex flex-col flex-1 pb-4 last:pb-0 last:border-0 border-b border-b-card-border dark:border-b-card-border-dark"
              >
                <span className="text-text-secondary text-sm">{el.label}</span>
                <span className="font-klein font-medium">{el.data}</span>
              </div>
            ))}
          </div>
          {confirmButton && (
            <BaseButton radius="lg" onClick={onConfirm}>
              Подтвердить
            </BaseButton>
          )}
        </div>
      ) : (
        <div className="flex bg-light-purple dark:bg-dark-purple p-6 rounded-2xl">
          {info.map((el, i) => (
            <div
              key={i}
              className="flex flex-col flex-1 pr-6 last:pr-0 pl-6 first:pl-0 last:border-0 border-r border-r-card-border dark:border-r-card-border-dark"
            >
              <span className="text-text-secondary text-sm">{el.label}</span>
              <span className="font-medium">{el.data}</span>
            </div>
          ))}
        </div>
      )}
    </>
  )
}
